export default __webpack_public_path__ + "static/media/icn-retarder.90c1d6f5.svg";